import { createStyles, rem } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  container: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "2rem",
    background: "#f5f5f5",
  },
  card: {
    background: "#fff",
    borderRadius: "12px",
    padding: "2.5rem",
    maxWidth: "550px",
    width: "100%",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.08)",
  },
  title: {
    fontSize: 24,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#000",
    marginBottom: 8,
  },
  subtitle: {
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 400,
    color: "#737373",
    marginBottom: 24,
  },
  radioBox: {
    border: "1px solid #E5E5E5",
    borderRadius: "8px",
    padding: "1rem 1.25rem",
    cursor: "pointer",
    transition: "all 0.2s ease",
    "&:hover": {
      borderColor: "#FFAF4A",
      background: "#f9fafb",
    },
  },
  radioBoxSelected: {
    border: "2px solid #FFAF4A",
    background: "#F5F5F5",
  },
  radioLabel: {
    fontFamily: "Inter",
    fontSize: "15px",
    fontWeight: 500,
    color: "#000",
  },
  radioDescription: {
    fontFamily: "Inter",
    fontSize: "13px",
    fontWeight: 400,
    color: "#737373",
    marginTop: "0.25rem",
  },
  continueBtn: {
    background: "#000",
    height: 40,
    fontFamily: "Inter",
    fontSize: "15px",
    borderRadius: "6px",
    color: "#FFF",
    fontWeight: 500,
    padding: "0 2rem",
    border: "none",
    cursor: "pointer",
    marginTop: 24,
    display: "block",
    marginLeft: "auto",
    "&:hover": {
      background: "#000",
    },
  },
  phoneInputWrapper: {
    width: "100%",
    border: "1px solid #ced4da",
    borderRadius: 8,
    padding: "5px 0",
    fontSize: "16px",
    fontFamily: "Inter",
    fontWeight: 400,
    alignItems: "center",
    lineHeight: "normal",
    backgroundColor: "#fff",

    "& button": {
      height: "2.625rem",
      border: "none",
    },
    "& input": {
      height: "2.625rem",
      border: "none",
    },

    "& .react-international-phone-input-container": {
      display: "flex",
      alignItems: "center",
      border: `1px solid red`,
      borderRadius: theme.radius.sm,
      height: "50px",
      padding: "0 0.5rem",
      transition: "border-color 0.2s ease, box-shadow 0.2s ease",
    },

    // Focus state (like Mantine inputs)
    "& .react-international-phone-input-container:focus-within": {
      borderColor: theme.colors.blue[6],
      boxShadow: `0 0 0 1px ${theme.colors.blue[6]}`,
    },

    "& .react-international-phone-country-selector": {
      border: "none !important",
      background: "transparent !important",
      height: "100%",
      padding: "0 0.5rem",
    },

    "& .react-international-phone-input": {
      flex: 1,
      border: "none !important",
      outline: "none !important",
      height: "100%",
      fontSize: "16px",
      fontFamily: "Inter, sans-serif",
    },
  },
  textInputBox: {
    width: "100%",
    marginTop: "12px",
    "& .mantine-TextInput-input": {
      border: "1px solid #E5E5E5",
      borderRadius: "6px",
      fontFamily: "Inter, sans-serif",
      fontSize: "14px",
      padding: "0.75rem",
      "&:focus": {
        borderColor: "#FFAF4A",
      },
    },
  },
  phoneEditRow: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginTop: "10px",
  },

  phoneDisplayRow: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },

  saveButton: {
    backgroundColor: "#FFAF4A",
    color: "#000",
    borderRadius: "6px",
    height: "30px",
    width: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#FFAF4A",
    },
  },
}));

export default useStyles;
